import axios from 'axios';

const PATH = `${process.env.REACT_APP_API_URL}`;

export function whoAmI() {
  return axios.get(`${PATH}/user/me`,
    {
      withCredentials: true
    });
}

export function login(ticket: string | null) {
  return axios.post(
    `${PATH}/login`,
    {
      ticket
    }
  );
}
